<template>
  <router-view />
</template>

<script>
export default {
  name: 'Assignments'
};
</script>

<style lang="scss" scoped></style>
